export default __webpack_public_path__ + "static/media/voice_disabled.adf269ee.svg";